export * from './ny-results-shop.module'
